import React, { useState, useEffect } from 'react';
import '../styles/About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );

    const element = document.getElementById('about');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div className={`about-section ${isVisible ? 'visible' : ''}`}>
      <div className="container">
        <h2 className="section-title">
          <span className="title-number">01.</span>
          About Me
        </h2>
        
        <div className="about-content">
          <div className="about-text">
            <p className="about-intro">
              I am a Computer Science and Engineering graduate with hands-on experience in AI automation, full-stack development, and workflow automation.
            </p>
            
            <p>
              I specialize in building AI-powered applications, internal tools, and scalable web solutions. I possess strong problem-solving skills combined with a genuine passion for developing practical, efficient solutions to real-world problems.
            </p>
            
            <ul className="tech-list">

            </ul>
          </div>
          
          <div className="about-image">
            <div className="profile-container">
              <div className="profile-card">
                <div className="profile-img-wrapper">
                  <div className="profile-initials">
                    PV
                  </div>
                </div>
                <div className="profile-info">
                  <h3 className="profile-name">Prajeeth Valavala</h3>
                  <p className="profile-title"></p>
                </div>
                <div className="profile-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">🎓</span>
                    <span className="highlight-text">Fresh Graduate</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">⚡</span>
                    <span className="highlight-text">Quick Learner</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">📈</span>
                    <span className="highlight-text">Passionate Coder</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
